import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Disabler } from 'lib/ui/components'
import { useCheckout, EmailForm, Nav } from 'lib/modules/checkout'
import { PaymentMethods } from 'components/PaymentMethods'
import { PaymentOptions } from 'components/PaymentOptions'
import { CheckoutAside } from '../../components/CheckoutAside'
import { BillingAddress } from './component/BillingAddress'
import {
  Container,
  CheckoutLayout,
  CheckoutMain
} from '../styled'

export const Billing = () => {
  const {
    validateShippingAddress,
    validateShippingMethod,
    requiresShipping,
    orderTotal,
    billingAddress
  } = useCheckout()
  const history = useHistory()
  const isValid = validateShippingAddress() && validateShippingMethod()
  const needsShipping = requiresShipping()

  useEffect(() => {
    if (!isValid) {
      history.replace('/checkout/shipping')
    }
  }, [isValid, history])

  return (
    <>
      <Nav />
      <Container>
        <h1>
          Payment & Billing Information
        </h1>
        <CheckoutLayout>
          <CheckoutMain>
            {!!orderTotal && (
              <Disabler disabled={billingAddress.isFetching}>
                <PaymentOptions />
                <PaymentMethods />
              </Disabler>
            )}

            {!needsShipping && (
              <EmailForm />
            )}

            <h2>
              Billing Address
            </h2>

            <BillingAddress />
          </CheckoutMain>
          <CheckoutAside />
        </CheckoutLayout>
      </Container>
    </>
  )
}
